export const trashItemResources = {
  en: {
    restore: 'Restore',
    deleteForever: 'Delete forever'
  }
};